import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'
import notifications from './modules/notifications'
import security from './modules/security'
import account from './modules/account'
import settlement from './modules/settlement'
import settlementreport from './modules/settlementreport'
import product from './modules/product'

Vue.use(Vuex)

/* eslint-disable no-new */
const store = new Vuex.Store({
  plugins: [createPersistedState()],
  modules: {
    notifications,
    security,
    account,
    settlement,
    settlementreport,
    product
  }
})

export default store
